function getPermissionNames(currentUser) {
  if (!currentUser) return [];
  const perms =
    currentUser.userRole?.permissions ||
    currentUser.permissions ||
    [];
  return perms
    .map((p) => (typeof p === "string" ? p : p?.name ?? p?.value))
    .filter(Boolean)
    .map((s) => String(s).trim().toLowerCase());
}

export default function checkPermission(requiredPermissions, currentUser) {
  if (!requiredPermissions?.length) return true;
  if (!currentUser) return false;
  const userPermNames = getPermissionNames(currentUser);
  const normalizedRequired = requiredPermissions.map((p) =>
    String(p).trim().toLowerCase()
  );
  return normalizedRequired.some((perm) => userPermNames.includes(perm));
}
